import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConsts } from 'src/app/common/app-consts';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { GPackagesModel, SaleDetailModel, SaveSaleMasterRequest, TagsModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { GQuotationDetail, GQuotationSaveModel, GQuotationTags, SaveGQuotationRequest } from 'src/app/viewmodels/g-quotation/QuotationModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { SaleDetailViewModel } from 'src/app/viewmodels/g-sale/SaleDetailViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { GPackageItemModel, SaveGVehicleRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-quotation-form',
  templateUrl: './quotation-form.component.html',
  styleUrls: ['./quotation-form.component.scss']
})
export class QuotationFormComponent implements OnInit {

  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  modalRef: BsModalRef;
  public vmListItems: any = [];
  @Input() public Id: any;
  @Input() public vmP: AccountDefiningModel;
  @Input() public vmp: GPackagesModel;
  @Input() public modal_title: any;
  private submitted = false;
  public vehicleDetail: any = [];
  public selectedTagsList: any = [];
  public cvehicleDetail = "vehicleDetail";
  public selectedvehicleDetail: any = [];
  public userAssignedWareHouses: Array<any> = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmDetail: number;
  public totalExpense: number = 0;
  public allowedExpense: number = 0;
  public spareParts: Array<any> = [];
  public selectedSpareParts: any = [];
  bsmRef: any;
  @Output() onSubmitted = new EventEmitter<any>();
  public tags: any = [];
  public selectedTagList: any = [];
  public citems: any = "items";
  public selectedDate: any;
  public DisableSave: boolean = false;
  public EnableNext: boolean = false;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;
  public SelectedItemServices: any = [];
  public services: any = [];
  public selectedemail: any = [];
  public customerAccount: ItemViewModel1;
  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };

  public noteDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public PackageSelectionDropdown: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1,
  };
  name = "cpEmail";
  id = "id";
  checked = true;
  isdisabled = false;
  label = "Toggle On/Off";
  labelledby = "Some Other Text";

  public itemTypes = [];
  public ssItemVm = new SaveItemRequest();
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "registrationNumber",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "accTitle",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1,
  };
  public customerDetail: any = [];
  public selectedcustomerDetail: any = [];
  public ccustomerDetail = "customerDetail";
  public selectedServices: any = [];
  public maxDate = new Date();
  public quotationSave: SaveGQuotationRequest = new SaveGQuotationRequest();
  public vehicleDetailObj: any;
  public quotationNumber: any;
  public quotationSubject: any = "New Quotation";
  public noteslist: any = [];
  selectedNote: ItemViewModel1 = new ItemViewModel1;
  noteText: string = "";
  public client: any;
  public user: any;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService,
    private route: ActivatedRoute
  ) { }

  files: File[] = [];
  public quoteNumberList: any;
  ngOnInit() {

    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.vmDetail = parseInt(this.client.Vat);
    this.itemVm.customer = new ItemViewModel1();

    this.Id = this.route.snapshot.paramMap.get('id') || '';
    if (!this.Id) {
      this.getQuoteNumbers();
    }
    this.getRegNo();
    this.getimage();
    this.getCustomers();
    //this.getRequisitions();
    this.getTags();
    this.getServices();
    this.getQuoteNotes();
    this.getItemTypes();
    if (
      this.itemVm.tagList !== undefined &&
      this.itemVm.tagList.length > 0
    ) {
      this.itemVm.tagList.forEach((x) => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    if (this.itemVm == undefined) {
      this.itemVm = new SaveGVehicleRequest();
      this.vehicleDetail = [];
      this.itemVm.customerDiscount = 0;
      this.itemVm.customerEmail = new ItemViewModel1(0, "");
      this.selectedvehicleDetail = [];
    } else {
    }
    if (this.vm == undefined) {
      this.vm = new SaveSaleMasterRequest();
      this.vm.customerAcc = new ItemViewModel1(0, "");
    } else {
    }
    if (this.vmP == undefined) {
      this.vmP = new AccountDefiningModel();
      this.customerDetail = [];
      this.selectedcustomerDetail = [];
    } else {
    }
    if (this.modal_title == undefined) {
      this.modal_title = "Sale";
    }
    if (this.vmp == undefined) {
      this.vmp = new GPackagesModel();
      this.vm = new SaveSaleMasterRequest();
      this.vm.transactionDate = new Date();
      this.vmp.spareParts = [];
      this.vmp.services = [];
      this.vm.paymentType = 1;
      this.vm.transactionDate = new Date();
      this.vm.statusType = new ItemViewModel1(8, "SaleInvoice");
      this.vm.customerAccEmail = new ItemViewModel1(0, "");
    } else {
      if (
        this.vm.salesTagsList !== undefined &&
        this.vm.salesTagsList.length > 0
      ) {
        this.vm.salesTagsList.forEach((x) => {
          this.selectedTagsList.push(new ItemViewModel1(x.id, x.name));
        });
      }

      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach((x) => {
          this.selectedSpareParts.push(
            new ItemViewModel1(
              x.ssItemDefining.id,
              x.ssItemDefining.name
            )
          );
        });
      }
      if (this.vmp.services !== undefined && this.vmp.services.length > 0) {
        this.vmp.services.forEach((x) => {
          this.selectedServices.push(
            new ItemViewModel1(
              x.ssItemDefining.id,
              x.ssItemDefining.name
            )
          );
        });
      }
    }

    if (this.Id == "" || this.Id == null || this.Id == undefined) {
      this.getUserAssingnedWareHouses().then((res: any) => {
        console.log("promise res", res);
        debugger

        this.getSpareParts(this.vehicleDetail[0].model.id, res.result[0].wareHouse.id);
      });
    }

  }

  getItemTypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
      console.log(res);
    }, (err) => this._uow.logger.log(err));
  }

  getQuoteNumbers() {
    this._uow.gSaleService.GetGQuotationRefIdAsync().subscribe(
      (res: any) => {
        // console.log(res);
        this.quotationNumber = res.code;
        this.quotationSave.quoteNumber = res.code;

      },
      (error) => {
        this._uow.logger.log(error);
        this.vehicleDetail = [];
      }
    );
  }

  getQuoteNotes() {

    this._uow.gSettingService.GetGQuotationNotesAsync().subscribe(
      (res: any) => {
        // console.log(res);
        debugger
        this.noteslist = res.result;
      },
      (error) => {
        this._uow.logger.log(error);

      }
    );
  }

  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  getRegNo() {
    debugger
    this.spinner.show();
    this._uow.gSettingService.GetGVehiclesByUserAsync().subscribe((res: any) => {
      debugger
      this.vehicleDetail = res.result;

      if (this.Id != "" || this.Id != null || this.Id != undefined) {
        this.getUserAssingnedWareHouses().then((res: any) => {
          console.log("promise res", res);
          debugger

          this.getSpareParts(this.vehicleDetail[0].model.id, res.result[0].wareHouse.id);
        });
      }

      this.spinner.hide();
    }, (error) => {
      this._uow.logger.log(error);
      this.spinner.hide();
    });
  }

  getCustomers() {
    debugger;
    let Customer = AppConsts.CUSTOMER;
    this._uow.gSettingService.GetGCustomersDropDownAsync(Customer).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result;
        if (this.customerDetail.length > 0) {
          // // debugger;
          this.customerDetail.forEach(x => {
            id: x.id;
            accTitle: x.accCode + '-' + x.accTitle
          });
        }
        this.vmP = res.result;
        this.vmP.accCode = res.accCode;
        this.vmP.accTitle = res.accCode + "" + res.accTitle;

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  // getRequisitions() {
  //   console.log(this.selectedvehicleDetail);
  //   this._uow.gSettingService.GetGVehiclesAsync().subscribe(
  //     (res: any) => {
  //       // console.log(res);
  //       this.vehicleDetail = res.result;
  //     },
  //     (error) => {
  //       this._uow.logger.log(error);
  //       this.vehicleDetail = [];
  //     }
  //   );
  // }
  getTags() {
    debugger
    this.tags = [];
    this._uow.gSettingService.GetTagsAsync().subscribe(

      (res: any) => {
        debugger
        this.tags = res.result;
      },
      (err) => console.log(err)
    );
  }

  getServices() {
    // 'Services'
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Services").subscribe(
      (res: any) => {
        this.services = res.result;
        console.log(res);
        this._jq.showSpinner();
        // this._uow.logger.log(`services ${res}`);
      },
      (err) => {
        this._uow.logger.log(err);
        this.services = [];
        this._jq.showSpinner();
      }
    );
  }

  getUserAssingnedWareHouses() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.userAssignedWareHouses = res.result;
        resolve(res);
      });
    });
  }

  getSpareParts(modelId, wareId?) {
    debugger;
    let selectedSpare: any = [];
    this._uow.gSettingService
      .GetItemsDropDownByModelAndTypeIdAsync(modelId, wareId)
      .subscribe(
        (res: any) => {
          debugger
          this.spareParts = res.result;
          this.InventoryCheckAll();
          console.log("spare parts", res);
          if (this.selectedSpareParts.length > 0) {
            console.log(this.selectedSpareParts);
            this.selectedSpareParts.forEach((x) => {
              let selected = this.vmp.spareParts.find((z) => z.ssItemDefining.id === x.id);
              console.log("selcetd part", selected);
              let md = new ItemViewModel1();
              md.id = selected.ssItemDefining.id,
                md.name = selected.ssItemDefining.name
              selectedSpare.push(md);
              this.selectedSpareParts = selectedSpare;
            });
          }

          if (this.Id != null && this.Id != undefined && this.Id != 0) {
            this.getQuotationById(this.Id);
          }
        },
        (err) => {
          this._uow.logger.log(err);
          this.spareParts = [];
        }
      );
  }

  onSelectvehicleDetail(e) {

    this._uow.logger.log(e);
    console.log('details', e);
    let selectedCustomerList: any = [];
    let selectedWareHouseList: any = [];

    let item = this.vehicleDetail.find((x) => x.id === e.id);
    this.vehicleDetailObj = this.vehicleDetail.find((x) => x.id === e.id);

    if (item !== undefined) {
      debugger
      this.itemVm = item;
      this.itemVm.name = item.name;
      this.itemVm.registrationNumber = item.registrationNumber;
      this.itemVm.tagList = item.tagList;
      this.itemVm.customer.id = item.customer.id;
      this.itemVm.customer.name = item.customer.name;
      // this.vm.FK_WareHouse_Id = new ItemViewModel(item.FK_WareHouse_Id.Id,item.FK_WareHouse_Id.Name);
      this.customerAccount = new ItemViewModel1(
        item.customer.id,
        item.customer.name
      );
      this.itemVm.customerDiscount = item.customerDiscount;
      if (this.itemVm.customer.id != null || this.itemVm.customer.id != undefined) {
        let custList = new AccountDefiningModel();
        custList.id = this.itemVm.customer.id;
        custList.accTitle = this.itemVm.customer.name;
        // this.itemVm.Fk_G_Customer_Id.Id =item.Id;
        // this.itemVm.Fk_G_Customer_Id.Name =item.Acc_Titel;
        custList.discountValue = this.itemVm.customerDiscount;
        selectedCustomerList.push({
          id: custList.id,
          accTitle: custList.accTitle,
          discountValue: custList.discountValue
        });
        console.log(this.itemVm);
        this.selectedcustomerDetail = selectedCustomerList;
      } else {
        this.selectedcustomerDetail = null;
        let cd = document.getElementById("customerdetail");
        cd.classList.add("required");
      }
    }
  }

  onDeSelectvehicleDetail(e) {

    if (this.selectedvehicleDetail.length == 0) {
      this.itemVm = new SaveGVehicleRequest();
      this.itemVm.registrationNumber = this.itemVm.registrationNumber;
      this.getRegNo();
      this.vmP = new AccountDefiningModel();
      this.vmP.id = this.vmP.id;
      this.vmP.accTitle = this.vmP.accTitle;
      this.selectedcustomerDetail = [];
      this.getCustomers();
    }
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveGVehicleRequest();
      this.itemVm.model = new ItemViewModel1();
      this.itemVm.customer = new ItemViewModel1();
      this.itemVm.customerEmail = new ItemViewModel1();
      this.itemVm.tag = new ItemViewModel1();
      this.itemVm.status = new ItemViewModel1();
    }
  }

  onSelectcustomerDetail(e) {
    let selectedCustomerL: any = [];
    this._uow.logger.log(e);
    let selectedVehicle: any = [];
    let item = this.customerDetail.find((x) => x.id === e.id);
    let item2 = this.vehicleDetail.find((y) => y.id === e.id);
    if (item !== undefined) {
      this.vmP = item;
      this.vmP.id = item.id;
      this.vmP.accTitle = item.accTitle;
      this.vmP.cpEmail = item.cpEmail;
      this.selectedemail.push(item);
      let VehList = new SaveSaleMasterRequest();
      VehList.gCustomer = new ItemViewModel1(0, "");
      VehList.gCustomer.id = item.id;
      VehList.gCustomer.name = item.accTitle;
      this.itemVm.customer.id = item.id;
      this.itemVm.customer.name = item.accTitle;
      this.customerAccount = new ItemViewModel1(item.id, item.accTitle);
      this.vmP.id = VehList.gCustomer.id;
      this.vmP.accTitle = VehList.gCustomer.name;
      selectedCustomerL.push(VehList);
    }
    selectedCustomerL = selectedVehicle = this.selectedvehicleDetail;
    selectedCustomerL = this.selectedcustomerDetail;
    selectedVehicle = this.selectedvehicleDetail;
  }

  onDeSelectcustomerDetail(e) {
    if (this.selectedcustomerDetail.length == 0) {
      this.vmP = new AccountDefiningModel();
      this.vmP.accTitle = this.vmP.accTitle;
      this.getRegNo();
    }
  }
  vatChanged() {

    if (this.vmDetail > -1) {
      if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach((x) => {
          x.vatValue = this.vmDetail;
          x.vatAmount = (x.totalAmount / 100) * this.vmDetail;
          // x.VatAmount =  (x.VatAmount.toFixed(2);
        });
      }
      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach((x) => {
          x.vatAmount = (x.amount / 100) * this.vmDetail;
          x.totalAmount = x.amount + x.vatAmount;
        });
      }

      if (this.vmp.services !== undefined && this.vmp.services.length > 0) {
        this.vmp.services.forEach((x) => {
          x.vatAmount = (x.amount / 100) * this.vmDetail;
          x.totalAmount = x.amount + x.vatAmount;
          // x.VatAmount =  x.VatAmount.toFixed(2);
          // x.VatAmount.toFixed(2);
        });
      }
      this.calculateTotals();
    }
  }
  public TotalPayable = 0;
  public TotalVat: number = 0;
  public TotalPayableAfterVat = 0;
  calculateTotals() {
    debugger
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.TotalPayable = 0;
    this.vmp.discountAmount = 0;
    this.vmp.partsAmount = 0;
    if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
      this.vmp.spareParts.forEach((x) => {
        this.vmp.partsAmount += x.amount;
        this.TotalVat += x.vatAmount;
        if (x.discountAmmount > 0) {
          this.vmp.discountAmount += x.discountAmmount * x.quantity;
        }
      });
      this.vmp.serviceAmount = 0;
      this.vmp.services.forEach((x) => {
        x.vatAmount = x.vatAmount;
        this.vmp.serviceAmount += x.amount;
        this.TotalVat += x.vatAmount;
        if (x.discountAmmount > 0) {
          this.vmp.discountAmount += x.discountAmmount * x.quantity;
        }
      });
    }
    this.vmp.packageAmount =
      this.vmp.partsAmount + this.TotalVat + this.vmp.serviceAmount;
    // if(this.vm.PaymentType === 3){
    this.totalExpense = this.vmp.packageAmount;
    this.allowedExpense = this.vmp.packageAmount;
    this.vm.allowedExpense = this.allowedExpense;
    this.vm.totalExpense = this.totalExpense;
    // }

  }

  onSelectWareHouse() {
    debugger
    this.getSpareParts(this.itemVm.model.id, this.vm.gWareHouse.id);
  }
  onSelectSparePart(e) {
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    this._uow.logger.log(e);
    let item = this.spareParts.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmp.spareParts.push(a);
      this.discountChange(this.vmp.spareParts[this.vmp.spareParts.indexOf(a)]);
      //this.selectedSpareParts.push(a);
    }
    this.vatChanged();
    this.calculateTotals();
    this.InventoryCheck(e.id);
  }

  onDeSelectSparePart(e) {

    let i = this.vmp.spareParts.find(
      (x) => x.ssItemDefining.id === e.id
    );
    if (i !== undefined) {
      this.vmp.spareParts.splice(this.vmp.spareParts.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    // let a = this.vm.SpareParts.find(x=> x.FK_G_Item_Id.Id === e.Id);
    //   if(a !== undefined){
    //     this.vm.SpareParts.splice(this.vm.SpareParts.indexOf(a),1);
    //   }

    this.calculateTotals();
    this.InventoryCheckAll();
  }


  InventoryCheck(e) {

    let SparepartsEvent = this.spareParts.find((y) => y.id === e);
    if (SparepartsEvent != undefined && SparepartsEvent != null) {
      let AlreadySelectedParts = this.vmp.spareParts.find(
        (y) => y.ssItemDefining.id === e
      );
      if (AlreadySelectedParts != undefined && AlreadySelectedParts != null) {
        let AlreadyPartsIndex = this.vmp.spareParts.indexOf(
          AlreadySelectedParts
        );
        if (AlreadySelectedParts.quantity > SparepartsEvent.currentStock) {
          if (AlreadyPartsIndex != undefined) {
            this.vmp.spareParts[AlreadyPartsIndex].isInventry = false;
          }
          //this.DisableSave = true;
        } else {
          if (AlreadyPartsIndex != undefined) {
            this.vmp.spareParts[AlreadyPartsIndex].isInventry = true;
          }
          AlreadySelectedParts.isInventry = true;
          //this.DisableSave = false;
        }
      }
    }
    this.InventoryCheckAll();
  }

  InventoryCheckAll() {

    if (this.vmp.spareParts != undefined && this.vmp.spareParts.length > 0) {
      this.vmp.spareParts.forEach((x) => {
        let SparepartsEvent = this.spareParts.find(
          (y) => y.id === x.ssItemDefining.id
        );
        if (SparepartsEvent != undefined && SparepartsEvent != null) {
          if (x.quantity > SparepartsEvent.currentStock) {
            x.isInventry = false;
            //this.DisableSave = true;
          } else {
            x.isInventry = true;
            //this.DisableSave = false;
          }
        }
      });
      let DisableSave = this.vmp.spareParts.find(x => x.isInventry === false);
      if (DisableSave) {
        this.DisableSave = true;
      } else {
        this.DisableSave = false;
      }
    } else {
      this.DisableSave = false;
    }
    this.DisableSave = false;
  }

  discountChange(e, i?) {
    debugger
    let discountAMmount = (e.discountPercentage * e.salePrice) / 100;
    e.discountAmmount = discountAMmount;
    e.discountAmount = e.salePrice - e.discountAmmount;
    e.amount = e.discountAmount * e.quantity;
    let saledtl = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledtl != undefined) {
      saledtl.rate = e.salePrice;
      saledtl.salePrice = e.salePrice;
      saledtl.discountAmount = e.discountAmmount;
      saledtl.discount = e.discountPercentage;
      saledtl.discountedRate = e.discountAmount;
      saledtl.totalAmount = e.amount;
    }
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount <= 0){
    //   let discountAMmount = ((e.DescountPercentage / 100) * e.Amount);
    //   e.Amount = (e.Amount - discountAMmount);
    //   this.calculateTotals();
    // }
    this.vatChanged();
    //this.calculateTotals();
  }

  openModalLg(template: TemplateRef<any>, itemtype?) {

    this.ssItemVm = new SaveItemRequest();
    if (itemtype == 1) {
      let i = this.itemTypes.find((x) => x.name == "Spare-Parts");
      console.log(i);
      this.ssItemVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    if (itemtype == 2) {
      let i = this.itemTypes.find((x) => x.name == "Services");
      this.ssItemVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    this.openModal(template);
    this.modalRef.setClass("modal-xl");
  }

  onSelectService(e) {
    debugger;
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    if (
      this.SelectedItemServices == undefined ||
      this.SelectedItemServices.length == 0
    ) {
      this.SelectedItemServices = [];
    }
    this._uow.logger.log(e);
    let item = this.services.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmp.services.push(a);
      this.discountChange(this.vmp.services[this.vmp.services.indexOf(a)]);
      this.SelectedItemServices.push(item);
    }
    this.vatChanged();
    this.calculateTotals();
  }

  onDeSelectService(e) {
    let i = this.vmp.services.find((x) => x.ssItemDefining.id === e.id);
    if (i !== undefined) {
      this.vmp.services.splice(this.vmp.services.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
  }

  quantityChange(e, i?) {
    //e.DiscountAmount = 0;
    e.amount = e.quantity * e.discountAmount;
    let saledetail = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledetail != undefined) {
      saledetail.quantity = e.quantity;
      saledetail.totalAmount = e.amount;
    }
    //  if (e.DescountPercentage > 0) {
    //    e.Amount = (e.Amount - ((e.DescountPercentage / 100) * e.Amount));
    //  }
    //this.calculateTotals();
    this.vatChanged();
    this.InventoryCheckAll();
  }

  amountChange(e, i?) {
    e.discountPercentage = (e.discountAmmount * 100) / e.salePrice;
    this.discountChange(e, i);
    this.vatChanged();

  }
  vatAmountChanged(i) {
    this.calculateTotals();
  }

  onSelectTags(e) {
    if (
      this.vm.salesTagsList == undefined ||
      this.vm.salesTagsList.length == 0
    ) {
      this.vm.salesTagsList = [];
    }
    this._uow.logger.log(e);
    let item = this.tags.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new TagsModel();
      i.id = item.id;
      i.name = item.name;
      i.fkTagId = item.id;
      this.vm.salesTagsList.push(i);
      // let a = new G_SaleMasterViewModel();
      // a.Id = item.Id;
      // a.Name = item.Name;
      // this.vm.SalesTags.push(i);
    }
  }

  onDeSelectTags(e) {
    let i = this.vm.salesTagsList.find((x) => x.fkTagId === e.id);
    if (i !== undefined) {
      this.vm.salesTagsList.splice(this.vm.salesTagsList.indexOf(i), 1);
    }
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
      this.modalRef.setClass("modal-lg");
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }


  onNoteSelected() {
    debugger

    this.noteText = this.selectedNote[0].name;
  }

  onNoteDeSelected() {
    this.noteText = "";
  }
  onSelect(e) {
    this.files.push(...e.addedFiles);

    this.vm.file = this.files;
  }
  onRemove(e) {
    console.log(e);
    this.files.splice(this.files.indexOf(e), 1);
  }

  getQuotationById(Id) {
    this.spinner.show();
    this._uow.gSaleService.GetGQuotationByIdAsync(Id).subscribe(
      (res: any) => {
        debugger
        var data = res;
        let selectedSaprePartsList: any = [];
        let selectedServicesList: any = [];
        let selectedTagLists: any = [];
        let selectedVehicle: any = [];
        let selectedCustomer: any = [];

        this.Id = data.id;
        this.quotationSave.id = data.id;
        this.quotationNumber = data.quoteNumber;
        this.quotationSubject = data.subject;
        this.vm.transactionDate = new Date(data.quoteDate);
        this.noteText = data.note;
        debugger
        const vehicle = this.vehicleDetail.find(v => v.registrationNumber === data.vehicle.name);
        this.vehicleDetailObj = {
          id: vehicle.id, // Get the found vehicle's Id
          registrationNumber: vehicle.registrationNumber,
          customer: {
            id: vehicle.customer.id,
            name: vehicle.customer.name
          },
          driverPhone: data.driverPhone,
        };


        let veh = new SaveGVehicleRequest();
        veh.id = vehicle.id;
        veh.registrationNumber = vehicle.registrationNumber;
        veh.registrationNumber = data.vehicleNumber;
        veh.odometer = data.odometer;
        veh.driverName = data.driverName;
        veh.driverPhone = data.driverPhone;
        veh.customer = {
          id: 0,  // Initialize Id if available
          name: data.customer.name || '' // Initialize Name if available
        },
          selectedVehicle.push(veh);
        this.selectedvehicleDetail = selectedVehicle;

        if (data.vat != undefined) {
          this.vmDetail = parseFloat(data.vat);
        }

        let cust = new AccountDefiningModel();
        cust.id = vehicle.customer.id,
          cust.accTitle = vehicle.customer.name
        //selectedCustomer.push(cust);
        selectedCustomer.push({
          id: cust.id,
          accTitle: cust.accTitle,
          discountValue: cust.discountValue
        });
        this.selectedcustomerDetail = selectedCustomer;



        this.itemVm = {
          id: 0,
          uniqueId: '',
          name: '',
          description: '',
          chassisNumber: '',
          engineNumber: '',
          bikeEnggPower: '',
          bikeGarage: '',
          colour: '',
          purchaseDate: '',
          modelYear: '',
          brand: null,
          model: null,
          customerEmail: null,
          tag: null,
          tagList: [],
          status: null,

          registrationNumber: data.vehicleNumber,
          odometer: data.odometer,
          driverName: data.driverName,
          driverPhone: data.driverPhone,
          customerDiscount: vehicle.customerDiscount,

          customer: {
            id: 0,
            name: data.customer.name
          }
        } as SaveGVehicleRequest;

        const warehouse = this.userAssignedWareHouses.find(w => w.wareHouse.name === data.werahouse.name);
        if (warehouse) {
          this.vm.gWareHouse = warehouse.wareHouse; // Directly assign the object reference
        }


        ////////////////
        data.gQuotationDetail.forEach(element => {
          if (element.type === "Service") {  // Filter for "Service" type
            let item = this.services.find((x) => x.name === element.itemName);
            if (item !== undefined) {
              let i = new SaleDetailModel();
              i.id = item.id;
              i.quantity = 1;
              i.item = new ItemViewModel1(item.id, item.name);

              let a = new GPackageItemModel();
              a.ssItemDefining = new ItemViewModel1(item.id, item.name);
              a.quantity = element.quantity,
                a.salePrice = element.rate,
                a.vatAmount = element.vatAmount,
                a.discountAmount = element.discountRate,
                a.discountPercentage = element.discountPercentage,
                a.discountAmmount = element.discountAmount,
                a.amount = element.totalAmount,
                a.totalAmount = element.totalAmountWithVat
              this.vmp.services.push(a);

              this.SelectedItemServices.push(item);
              //this.discountChange(a, 0);
            }
          }
          if (element.type === "Part") {  // Filter for "Service" type
            let item = this.spareParts.find((x) => x.name === element.itemName);
            if (item !== undefined) {
              let i = new SaleDetailModel();
              i.id = 0;
              i.quantity = 1;
              i.item = new ItemViewModel1(item.id, item.name);

              let a = new GPackageItemModel();
              a.ssItemDefining = new ItemViewModel1(item.id, item.name);
              a.quantity = element.quantity,
                a.salePrice = element.rate,
                a.vatAmount = element.vatAmount,
                a.discountAmount = element.discountRate,
                a.discountPercentage = element.discountPercentage,
                a.discountAmmount = element.discountAmount,
                a.amount = element.totalAmount,
                a.totalAmount = element.totalAmountWithVat
              this.vmp.spareParts.push(a);

              this.selectedSpareParts.push(item);
              //this.discountChange(a, 0);
            }
          }
        });

        debugger

        /////////////
        this.vmp = {
          id: data.id || null, // or another appropriate default value
          name: data.name || '', // populate based on your data structure
          description: data.description || '',
          packageType: data.packageType || null, // populate based on your data structure
          spareParts: this.vmp.spareParts
            .map(detail => ({
              ssItemDefining: detail.ssItemDefining,
              quantity: detail.quantity,
              salePrice: detail.salePrice,
              vatAmount: detail.vatAmount,
              amount: detail.amount,
              discountPercentage: detail.discountPercentage,
              discountAmmount: detail.discountAmmount,
              totalAmount: detail.totalAmount,
              discountAmount: detail.discountAmount
            })),

          services: this.vmp.services
            .map(detail => ({
              ssItemDefining: detail.ssItemDefining,
              quantity: detail.quantity,
              salePrice: detail.salePrice,
              vatAmount: detail.vatAmount,
              amount: detail.amount,
              discountPercentage: detail.discountPercentage,
              discountAmmount: detail.discountAmmount,
              totalAmount: detail.totalAmount,
              discountAmount: detail.discountAmount
            })),

          // Populate any additional required properties here
          serviceAmount: data.serviceTotal || 0, // Ensure this is included
          partsAmount: data.partsTotal || 0, // Ensure this is included
          discountAmount: data.totalDiscount || 0, // Ensure this is included

          packageAmount: data.total || 0 // Ensure this is included
        } as GPackagesModel;
        this.TotalVat = data.totalVat;

        this.vm.salesTagsList = this.vm.salesTagsList || [];
        data.gQuotationTags.forEach(tag => {
          // Step 2: Create a new G_TagsViewModel instance
          let tg = this.tags.find((x) => x.name === tag.tag);
          const selectedTag = new TagsModel();
          selectedTag.id = tg.id;
          selectedTag.fkTagId = tag.fkTagId;
          selectedTag.name = tag.tag; // Assign the tag name directly from the data

          // Step 3: Push the selected tag into the selectedTagLists array
          selectedTagLists.push(selectedTag);
          this.vm.salesTagsList.push(selectedTag);
        });

        // Step 4: Assign the selectedTagLists to this.selectedTagsList for display
        this.selectedTagsList = selectedTagLists;

        if (this.itemVm.tagList !== undefined && this.itemVm.tagList.length > 0) {
          this.selectedTagList = this.itemVm.tagList.map(tag =>
            new ItemViewModel1(tag.id, tag.name)
          );
        }

        // Set other totals and file
        this.TotalVat = data.totalVat;
        this.vm.file = data.file;

        console.log(res);
        this.spinner.hide();
        this._jq.showSpinner();
      },
      (err) => {
        this.spinner.hide();
        console.log(err);
        this._jq.showSpinner();
      }
    );
  }

  OnSubmit() {

    this.spinner.show();
    //this.quotationSave.id = this.id;
    this.quotationSave.vehicle = new ItemViewModel1(this.vehicleDetailObj.id, this.vehicleDetailObj.registrationNumber);
    this.quotationSave.customer = new ItemViewModel1(this.vehicleDetailObj.customer.id, this.vehicleDetailObj.customer.name);
    this.quotationSave.vehicleNumber = this.vehicleDetailObj.registrationNumber;
    this.quotationSave.odometer = this.itemVm.odometer.toString();
    this.quotationSave.driverName = this.itemVm.driverName;
    this.quotationSave.driverPhone = this.vehicleDetailObj.driverPhone;
    this.quotationSave.quoteDate = new Date(this.vm.transactionDate);
    this.quotationSave.subject = this.quotationSubject;
    this.quotationSave.quoteNumber = this.quotationNumber;
    this.quotationSave.customerCode = this.vehicleDetailObj.customer.name;
    this.quotationSave.vat = this.vmDetail;
    this.quotationSave.werahouse = new ItemViewModel1(this.vm.gWareHouse.id, this.vm.gWareHouse.name);
    this.quotationSave.note = this.noteText;
    debugger

    this.quotationSave.gQuotationDetail = [
      ...this.vmp.spareParts.map(part => ({
        id: 0,
        gQuotationId: this.quotationSave.id || 0,

        itemName: part.ssItemDefining.name,
        type: "Part",
        quantity: part.quantity,
        rate: part.salePrice,
        vatAmount: part.vatAmount,

        discountRate: part.amount,
        discountPercentage: part.discountPercentage,  // FIXED spelling
        discountAmount: part.discountAmmount,

        totalAmount: part.discountAmount,
        totalAmountWithVat: part.totalAmount
      } as GQuotationDetail)),

      ...this.vmp.services.map(part => ({
        id: 0,
        gQuotationId: this.quotationSave.id || 0,

        itemName: part.ssItemDefining.name,
        type: "Service",
        quantity: part.quantity,
        rate: part.salePrice,
        vatAmount: part.vatAmount,

        discountRate: part.amount,
        discountPercentage: part.discountPercentage,  // FIXED spelling
        discountAmount: part.discountAmmount,

        totalAmount: part.discountAmount,
        totalAmountWithVat: part.totalAmount
      } as GQuotationDetail))
    ];


    this.quotationSave.gQuotationTags = this.vm.salesTagsList.map(part => {
      return {
        // Map the necessary fields from SpareParts to GQuotationDetail
        tag: part.name,
      } as GQuotationTags;
    });
    this.quotationSave.file = this.vm.file;
    this.quotationSave.serviceTotal = this.vmp.serviceAmount;
    this.quotationSave.partsTotal = this.vmp.partsAmount;
    this.quotationSave.totalDiscount = this.vmp.discountAmount;
    this.quotationSave.totalVat = this.TotalVat;
    this.quotationSave.total = this.vmp.packageAmount;

    this._uow.gSaleService
      //.Post(this.quotationSave)
      .SaveGQuotationAsync(this.quotationSave)
      .toPromise()
      .then((res: any) => {
        console.log(res);

        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        //this.bsmRef.hide();
        this.vm = res;
        this.EnableNext = true;
        this.spinner.hide();
        Swal.fire("Saved!", "Quotation Created!", "success");
        // this._jq.showSpinner();
        this._router.navigate(["/quotation"]);
      })
      .catch((error) => {
        Swal.fire("Error!", "Quotation Not Saved!", "error");
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        this.spinner.hide();
      });

  }

















































































  onItemSubmitted(e) {
    if (e == true) {
      //this.getList();
      this.getTags();
      this._jq.showSpinner(false);
    }
  }
  // getList() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe(
  //     (res: any) => {
  //       this.vmListItems = res.DtlList;
  //       console.log(res);
  //       this._jq.showSpinner();
  //     },
  //     (err) => {
  //       console.log(err);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  // private serialCounter: number = 1000000;
  // generateUniqueRandomString(): string {
  //   this.serialCounter = 1000000;
  //   let newSerialNumber: string;

  //   // Loop until a unique string is generated
  //   do {
  //     newSerialNumber = this.generateRandomString();
  //   } while (this.quoteNumberList.includes(newSerialNumber)); // Check if the string already exists in requestCodes

  //   return newSerialNumber;
  // }
  // generateRandomString(): string {
  //   const currentSerialNumber = this.serialCounter++;

  //   // Use the custom padStart function to ensure it's always 7 digits long
  //   return 'QT-' + this.padStart(currentSerialNumber.toString(), 7, "0");
  // }

  // padStart(str: string, targetLength: number, padString: string): string {
  //   while (str.length < targetLength) {
  //     str = padString + str;
  //   }
  //   return str;
  // }





}
